import React from 'react'
import { newConversationPath } from '../routes/path'
import type { Review as ReviewType } from '../supplier_show/prop_shapes/review'

interface AuthorInfoProps {
  review: ReviewType
}

export function AuthorInfo ({ review }: AuthorInfoProps): JSX.Element {
  const { author } = review
  return (
    <div className='grid-x'>
      <div className='shrink cell'>
        <img
          src={author.thumbnail}
          alt={author.name}
          className='img-rounded img-responsive'
          width='40'
          height='40'
        />
      </div>
      <div className='auto cell'>
        <div className='author-details'>
          <div className='font-bold pro-text-xs'>{author.name}</div>
          <div className='font-italic'>{author.organization}</div>
          {review.can_direct_message && (
            <a
              href={newConversationPath(review.id)}
              data-remote='true'
              className='direct-message pro-text-xs bold'
            >
              <i className='fa-regular fa-comment' /> Direct Message
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
